import dynamic from 'next/dynamic';
import {createTranslator, useTranslations, type AbstractIntlMessages} from 'next-intl';
import withMainLayout from 'layouts/main';
import {pageMessagesProps} from 'helpers/i18n';
import HeroSection from '@/content/industry-healthcare/hero';
import shared from '../messages/en/shared.json';
import industryHealthcare from '../messages/en/industryHealthcare.json';

const FeaturesSection = dynamic(
  () => import('@/content/industry-healthcare/features-section'),
  {loading: () => null}
);
const SplitFeaturesSection = dynamic(
  () => import('@/content/industry-healthcare/split-features-section'),
  {loading: () => null}
);
const CustomerStoriesSection = dynamic(
  () => import('@/content/industry-healthcare/customer-stories-section'),
  {loading: () => null}
);
const FaqSection = dynamic(() => import('@/content/industry-healthcare/faq-section'), {
  loading: () => null
});
const PreFooter = dynamic(() => import('../components/prefooter'), {
  loading: () => null
});

const IndustryHealthcarePage = () => {
  const t = useTranslations('industryHealthcare.prefooter');

  return (
    <>
      <HeroSection />
      <FeaturesSection />
      <SplitFeaturesSection />
      <CustomerStoriesSection />
      <FaqSection />
      <PreFooter title={t('title')} subtitle="" />
    </>
  );
};

type PageMessagesProps = {
  locale: string;
  messages: AbstractIntlMessages;
};

const seoMetas = (props: PageMessagesProps) => {
  const t = createTranslator({
    locale: props.locale,
    messages: props.messages
  }) as (key: string) => string;

  return {
    title: t('industryHealthcare.seo.title'),
    description: t('industryHealthcare.seo.description'),
    canonical: t('industryHealthcare.seo.canonical')
  };
};

export const messagesForIntl = {shared, industryHealthcare};

export function getStaticProps() {
  return pageMessagesProps(messagesForIntl);
}

export default withMainLayout(IndustryHealthcarePage, seoMetas as never);
